'use client';

import { useEffect, useRef } from 'react';
import { artifactDefinitions } from './artifact';
import { initialArtifactData, useArtifact } from '@/hooks/use-artifact';
import { useDataStream } from './data-stream-provider';
import { useWorkspace } from '@/store/useWorkspace';

export function DataStreamHandler() {
  const { dataStream } = useDataStream();
  const openArtifact = useWorkspace((s) => s.openArtifact);

  const { artifact, setArtifact, setMetadata } = useArtifact();
  const lastProcessedIndex = useRef(-1);

useEffect(() => {
  // console.log("dataStream:", dataStream);
  // console.log("typeof dataStream:", typeof dataStream);
  if (dataStream) console.log("keys:", Object.keys(dataStream));
}, [dataStream]);

useEffect(() => {
  if (!dataStream || dataStream.length === 0) return;

  // Get the latest part added to the array
  const lastPart = dataStream[dataStream.length - 1];

  switch (lastPart?.type) {
    case "data-kind":
    case "data-id":
    case "data-title":
    case "data-clear":
    case "data-textDelta":
    case "data-codeDelta":
      openArtifact(); // Hide builder, show artifact
      break;
  }
}, [dataStream, openArtifact]);

  // useEffect(() => {
  //   if (!dataStream || dataStream.length === 0) return;

  //   // Process only new stream parts
  //   for (let i = lastProcessedIndex.current + 1; i < dataStream.length; i++) {
  //     const delta = dataStream[i];
  //     lastProcessedIndex.current = i;

  //     setArtifact((draft) => {
  //       // safety: ensure we have a draft object
  //       const draftArtifact = draft || initialArtifactData();

  //       switch (delta.type) {

  //         case 'data-id':
  //           return {
  //             ...draftArtifact,
  //             documentId: delta.data,
  //             isVisible: true,
  //             status: 'streaming',
  //           };
  //         // indicates the kind of artifact (text, code, image, sheet)
  //         case 'data-kind': {
  //           try {
  //             // open the artifact UI and switch mode once a kind is received
  //             useWorkspace.getState().openArtifact();
  //           } catch (e) {
  //             // no-op (defensive): if useWorkspace is shadowed, skip
  //             console.warn('Failed to open workspace artifact', e);
  //           }
  //           return {
  //             ...draftArtifact,
  //             kind: delta.data,
  //             isVisible: true,
  //             status: 'streaming',
  //           };
  //         }

  //         // title for the document/artifact
  //         case 'data-title': {
  //           return {
  //             ...draftArtifact,
  //             title: delta.data,
  //             isVisible: true,
  //             status: 'streaming',
  //           };
  //         }

  //         // incremental text content (append)
  //         case 'data-textDelta':
  //         case 'data-text': {
  //           const incoming = typeof delta.data === 'string' ? delta.data : String(delta.data);
  //           return {
  //             ...draftArtifact,
  //             content: (draftArtifact.content || '') + incoming,
  //             isVisible: true,
  //             status: 'streaming',
  //           };
  //         }

  //         // metadata suggestions or other structured metadata
  //         case 'data-metadata': {
  //           try {
  //             const meta = typeof delta.data === 'string' ? JSON.parse(delta.data) : delta.data;
  //             setMetadata(meta);
  //           } catch (e) {
  //             // treat as raw
  //             setMetadata({ raw: delta.data });
  //           }
  //           return draftArtifact;
  //         }

  //         // clear content (start fresh)
  //         case 'data-clear': {
  //           try {
  //             useWorkspace.getState().openArtifact();
  //           } catch (e) {}
  //           return {
  //             ...draftArtifact,
  //             content: '',
  //             isVisible: true,
  //             status: 'streaming',
  //           };
  //         }

  //         // stream finished
  //         case 'data-finish': {
  //           return {
  //             ...draftArtifact,
  //             status: 'idle',
  //           };
  //         }

  //         default: {
  //           // unknown event types may be used by other providers - ignore
  //           return draftArtifact;
  //         }
  //       }
  //     });
  //   }
  // }, [dataStream, setArtifact, setMetadata, artifact]);

  return null;
}